const {
  NODE_ENV: env,
  BASE_URL: baseUrl,
  API_BASE_URL: apiBaseUrl,
  FLUTTERWAVE_ENV: flutterWaveEnv,
  GA_MEASUREMENT_ID: gaMeasurementId,
} = process.env;

export default {
  env,
  baseUrl,
  apiBaseUrl,
  flutterWaveEnv,
  isDev: env === 'development',
  gaMeasurementId,
};
